import { Navigate, Outlet } from 'react-router-dom';
import { useReadLocalStorage } from 'usehooks-ts';

import * as routes from 'router/routes';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';

const MfaRoute = () => {
  const mfaToken = useReadLocalStorage(LOCAL_STORAGE_KEY.MFA_TOKEN, STRING_STORAGE_VALUE_OPTIONS);

  if (!mfaToken) {
    return <Navigate replace to={routes.home} />;
  }

  return <Outlet />;
};

export default MfaRoute;
